import { createEntityAdapter } from "@reduxjs/toolkit";
import { FormDefinition } from "./dataTypes";

export const formDefinitionAdapter = createEntityAdapter<FormDefinition>({});
